import { texmlApplicationsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const TEXML_APPLICATIONS_ACTION_TYPE = createNamedActions('texml-applications', {
  GET_TEXML_APPLICATIONS: 'GET_TEXML_APPLICATIONS',
  GET_TEXML_APPLICATION: 'GET_TEXML_APPLICATION',
  CREATE_TEXML_APPLICATION: 'CREATE_TEXML_APPLICATION',
  UPDATE_TEXML_APPLICATION: 'UPDATE_TEXML_APPLICATION',
  DELETE_TEXML_APPLICATION: 'DELETE_TEXML_APPLICATION',
  GET_PHONE_NUMBERS: 'GET_PHONE_NUMBERS',
  RESET_TEXML_APPLICATIONS_STATE: 'RESET_TEXML_APPLICATIONS_STATE',
});

export const getTexmlApplicationsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await texmlApplicationsApi.getTexmlApplications();

  return dispatch({
    type: TEXML_APPLICATIONS_ACTION_TYPE.GET_TEXML_APPLICATIONS,
    payload: data?.data ?? [],
  });
});

export const getTexmlApplicationAction = catchAsyncActionError(({ id }) => async dispatch => {
  const { data } = await texmlApplicationsApi.getTexmlApplication({ id });

  return dispatch({
    type: TEXML_APPLICATIONS_ACTION_TYPE.GET_TEXML_APPLICATION,
    payload: data,
  });
});

export const createTexmlApplicationAction = catchAsyncActionError(
  ({ data: requestData }) =>
    async dispatch => {
      const { data } = await texmlApplicationsApi.createTexmlApplication({
        data: requestData,
      });

      return dispatch({
        type: TEXML_APPLICATIONS_ACTION_TYPE.CREATE_TEXML_APPLICATION,
        payload: data,
      });
    },
);

export const updateTexmlApplicationAction = catchAsyncActionError(
  ({ id, data: requestData }) =>
    async dispatch => {
      const { data } = await texmlApplicationsApi.updateTexmlApplication({
        id,
        data: requestData,
      });

      return dispatch({
        type: TEXML_APPLICATIONS_ACTION_TYPE.UPDATE_TEXML_APPLICATION,
        payload: data,
      });
    },
);

export const deleteTexmlApplicationAction = catchAsyncActionError(({ id }) => async dispatch => {
  await texmlApplicationsApi.deleteTexmlApplication({ id });

  return dispatch({
    type: TEXML_APPLICATIONS_ACTION_TYPE.DELETE_TEXML_APPLICATION,
    payload: id,
  });
});

export const getPhoneNumbersAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await texmlApplicationsApi.getPhoneNumbers();

  return dispatch({
    type: TEXML_APPLICATIONS_ACTION_TYPE.GET_PHONE_NUMBERS,
    payload: data?.data ?? [],
  });
});

export const resetTexmlApplicationsStateAction = () => ({
  type: TEXML_APPLICATIONS_ACTION_TYPE.RESET_TEXML_APPLICATIONS_STATE,
});
